export default context => {
  if (process.env.NODE_ENV !== 'production' || context.route.query.hasOwnProperty('showErrors')) {
    return context.store.dispatch('setShowErrors', true)
  }
}
